import { ContentfulPhone } from "../../../../ContentfulTypes";

const phoneFiltersVerification = (formattedPhone: ContentfulPhone, storedFilters) => {
  const storedFiltersKeys = Object.keys(storedFilters || {});

  const checkFilterItem = (filterItems, phone) => Object.keys(filterItems).some(
    (filterItem) => filterItems[filterItem]
        && phone.smartFilters.some((tag) => tag.cmsName === filterItem),
  );

  const checkFilterCategory = (filterCat, filterGroup) => {
    const filterItems = storedFilters[filterGroup][filterCat];
    const isCategoryActive = Object.values(filterItems).some(Boolean);
    return !isCategoryActive || checkFilterItem(filterItems, formattedPhone);
  };

  const checkFilterGroup = (filterGroup) => {
    const filterCategories = Object.keys(storedFilters[filterGroup]);
    return filterCategories.every((filterCat) => checkFilterCategory(filterCat, filterGroup));
  };

  return storedFiltersKeys.every(checkFilterGroup);
};

export default phoneFiltersVerification;
